import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-cameras',
    templateUrl: './cameras.component.html',
    styleUrls: ['./cameras.component.css']
})
export class CamerasComponent implements OnInit {

    key: string;

    constructor(private activatedRoute: ActivatedRoute, private titleService: Title) {
        titleService.setTitle('Wissle Cameras');
     }

    ngOnInit() {
        this.activatedRoute.params
			.subscribe(params => {
				this.key = params.key;
			});
    }

}
 